export default __webpack_public_path__ + "static/process7-32dff29ce117d8ed795209a3a958a20e.png";